// ============================================================================
// lib/tags.ts — SSoT-клиент универсальных тегов (TagService): дерево тегов и
// полиморфные связи с ЛЮБЫМИ объектами (справочники/документы/сообщения/файлы/
// заявки/задачи...). Ключ субъекта — type|code|id (совпадает с серверным).
// ============================================================================

import { getSDK } from '@/store/sdkStore';

export interface TagInfo {
  id: string;
  name: string;
  parentId: string;
  path: string;
  color: string;
  usageCount: number;
}

export interface TagSubjectRef {
  subjectType: string;
  subjectCode: string;
  subjectId: string;
}

export function tagKey(type: string, code: string, id: string): string {
  return `${type}|${code || ''}|${id}`;
}

function toTag(t: any): TagInfo {
  return {
    id: String(t?.id || ''),
    name: String(t?.name || ''),
    parentId: String(t?.parentId || ''),
    path: String(t?.path || ''),
    color: String(t?.color || ''),
    usageCount: Number(t?.usageCount || 0),
  };
}

export async function listTags(search = ''): Promise<TagInfo[]> {
  const r: any = await getSDK().tags.listTags({ search });
  return (r?.tags || []).map(toTag);
}

export async function saveTag(p: { id?: string; name: string; parentId?: string; color?: string }): Promise<string> {
  const r: any = await getSDK().tags.saveTag({
    id: p.id || '',
    name: p.name,
    parentId: p.parentId || '',
    color: p.color || '',
  });
  return String(r?.id || '');
}

export async function deleteTag(id: string): Promise<void> {
  await getSDK().tags.deleteTag({ id });
}

export async function setSubjectTags(ref: TagSubjectRef, tagIds: string[]): Promise<number> {
  const r: any = await getSDK().tags.setSubjectTags({
    subject: {
      subjectType: ref.subjectType,
      subjectCode: ref.subjectCode || '',
      subjectId: ref.subjectId,
    },
    tagIds,
  });
  return Number(r?.count || 0);
}

export async function listTagsForSubjects(refs: TagSubjectRef[]): Promise<Record<string, TagInfo[]>> {
  const out: Record<string, TagInfo[]> = {};
  if (!refs.length) return out;
  const r: any = await getSDK().tags.listSubjectTags({
    subjects: refs.map((x) => ({
      subjectType: x.subjectType,
      subjectCode: x.subjectCode || '',
      subjectId: x.subjectId,
    })),
  });
  const items = r?.items || {};
  for (const [key, list] of Object.entries<any>(items)) {
    out[key] = ((list?.tags) || []).map(toTag);
  }
  return out;
}

export async function listSubjectTags(ref: TagSubjectRef): Promise<TagInfo[]> {
  const m = await listTagsForSubjects([ref]);
  return m[tagKey(ref.subjectType, ref.subjectCode, ref.subjectId)] || [];
}
